import React from "react";
import AboutMe from "../general/AboutMe";
import "animate.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import AbhishekRai from "../../assets/member/AbhishekRai.jpeg";
import RajKumar from "../../assets/member/RajKumarMishra.jpg";
import KrishnaPandey from "../../assets/member/KrishnaPandey.jpeg";
import NirajPandey from "../../assets/member/NirajPandey.png";
import AvinashSri from "../../assets/member/AvinashSrivastava.jpeg";
import SagarKataria from "../../assets/member/SagarKataria.jpg";
import BioFuel from "../../assets/bio-fuel.jpeg";
import EventMgt from "../../assets/event-mgt.jpeg";
import RealEstate from "../../assets/real-estate.jpeg";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* banner section */}
      <section className="header-banner-bg">
        <div className="container text-center">
          <h1 className="banner-heading">
            SWALOK GROUP
            <br /> Real Estate Industry Leader
          </h1>
          <p className="banner-content">
            Offering Luxury homes, business districts, and modern retail spaces,
            all designed to meet the evolving needs of communities and
            businesses.
          </p>
          <button
            className="banner-btn mt-4"
            onClick={() => navigate("/about")}
          >
            Explore Us <i className="fa-solid fa-arrow-right"></i>
          </button>

          <button
            className="banner-btn2"
            onClick={() => {
              const element = document.getElementById("deal");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" }); // Smooth scroll to the target element
              }
            }}
          >
            <i className="fa-solid fa-arrow-down animate__animated animate__fadeInDown animate__infinite"></i>
          </button>
        </div>
      </section>
      {/* banner section ends */}

      {/* services section */}
      <section className="my-5">
        <div className="container text-center px-4">
          <div className="sec-subheading">
            <hr />
            <span>Our Specialty</span>
            <hr />
          </div>
          <p className="sec-heading">The Smartest Way to buy a home</p>

          <div className="row mt-5">
            <div className="col-lg-3 col-md-6 col-12 my-2">
              <i className="fa-solid fa-building-flag service-icon"></i>
              <p className="fs-5 my-3">Property Development</p>
              <p className="text-muted">
                We specialize in developing residential, commercial, and
                mixed-use properties, creating modern, high-quality spaces that
                meet the needs of people for sustainable living and growth.
              </p>
            </div>

            <div className="col-lg-3 col-md-6 col-12 my-2">
              <i className="fa-solid fa-piggy-bank service-icon"></i>
              <p className="fs-5 my-3">No Downpayment</p>
              <p className="text-muted">
                We offer flexible financing options with no downpayment
                required, making homeownership accessible to more people by
                removing financial barriers and allowing you to invest in your
                dream property.
              </p>
            </div>

            <div className="col-lg-3 col-md-6 col-12 my-2">
              <i className="fa-solid fa-person-shelter service-icon"></i>
              <p className="fs-5 my-3">Expert Guides to help you</p>
              <p className="text-muted">
                Our experienced real estate professionals provides personalized
                guidance throughout the buying, selling, or leasing process,
                ensuring you make informed decisions every step of the way.
              </p>
            </div>

            <div className="col-lg-3 col-md-6 col-12 my-2">
              <i className="fa-solid fa-tags service-icon"></i>
              <p className="fs-5 my-3">Reasonable Rates</p>
              <p className="text-muted">
                We offer competitive pricing on all our properties, with
                transparent pricing structures and affordable options, making it
                easier to find a property that fits your budget without
                compromising quality.
              </p>
            </div>
          </div>
          {/* row ends */}
        </div>
      </section>
      {/* services section ends */}

      {/* offer section */}
      <section className="pt-lg-5" id="deal">
        <div className="container text-center">
          <div className="sec-subheading">
            <hr />
            <span>What we provide</span>
            <hr />
          </div>
          <p className="sec-heading">Exclusive Deal We Offer</p>

          <div className="row mt-4">
            <div className="col-lg-4 col-md-6 col-12 my-2 px-4">
              <div className="offer-area-outer h-auto">
                <img
                  src={RealEstate}
                  className="img-fluid"
                  alt="Exclusive Offers"
                />
                <div className="offer-area">
                  <p className="fw-bold fs-5 mt-0">Real Estate</p>
                  <p className="text-muted para-text my-0">
                    Exclusive properties, unmatched investment opportunities.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 my-2 px-4">
              <div className="offer-area-outer h-auto">
                <img
                  src={EventMgt}
                  className="img-fluid"
                  alt="Exclusive Offers"
                />
                <div className="offer-area">
                  <p className="fw-bold fs-5 mt-0">Event Management</p>
                  <p className="text-muted para-text my-0">
                    Flawless events, unforgettable experiences guaranteed.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 my-2 px-4">
              <div className="offer-area-outer h-auto">
                <img
                  src={BioFuel}
                  className="img-fluid"
                  alt="Exclusive Offers"
                />
                <div className="offer-area">
                  <p className="fw-bold fs-5 mt-0">Bio Fuel</p>
                  <p className="text-muted para-text my-0">
                    Sustainable energy, cleaner future solutions.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* row ends */}
        </div>
      </section>
      {/* offer section ends */}

      {/* How it works section */}
      <section className="my-5 px-4">
        <div className="container work-bg px-0 text-light">
          <div className="col-lg-6 col-12 work-bg-content">
            <div className="sec-subheading">
              <hr />
              <span>Benefits</span>
              <hr />
            </div>
            <p className="sec-heading">Exclusive Offer For You</p>

            <div className="row mt-5">
              <div className="col-lg-6 col-md-6 col-12 my-3">
                <span className="work-num">01</span>
                <p className="fs-4 mt-4">Prime Locations</p>
                <p>
                  {" "}
                  Invest in strategically located properties that provide high
                  returns and long-term growth potential.
                </p>
              </div>

              <div className="col-lg-6 col-md-6 col-12 my-3">
                <span className="work-num">02</span>
                <p className="fs-4 mt-4">Superior Quality</p>
                <p>
                  Enjoy high-quality property with attention to detail, ensuring
                  comfort, durability, and luxury living.
                </p>
              </div>

              <div className="col-lg-6 col-md-6 col-12 my-3">
                <span className="work-num">03</span>
                <p className="fs-4 mt-4">Classic Deals</p>
                <p>
                  Benefit from competitive pricing, special discounts, and
                  customized payment plans tailored to your needs.
                </p>
              </div>

              <div className="col-lg-6 col-md-6 col-12 my-3">
                <span className="work-num">04</span>
                <p className="fs-4 mt-4">Comprehensive Support</p>
                <p>
                  Get guidance along the entire purchasing process, ensuring a
                  seamless experience.
                </p>
              </div>
            </div>
            {/* row ends */}
          </div>
        </div>
      </section>

      {/* How it works section ends */}

      <AboutMe />

      {/* Agents section */}
      {/* <section className="my-5">
        <div className="container text-center">
          <div className="sec-subheading">
            <hr />
            <span>Members</span>
            <hr />
          </div>
          <p className="sec-heading">Our Management Group</p>

          <Swiper
            spaceBetween={30}
            slidesPerView={4}
            modules={[Autoplay]}
            loop={true}
            autoplay={{ delay: 2000 }}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              576: {
                slidesPerView: 2,
              },
              768: {
            
                slidesPerView: 3,
              },
              992: {
                slidesPerView: 4,
              },
            }}
          >
            <SwiperSlide>
              <div className="my-2 offer-area-outer px-3">
                <img
                  src={AvinashSri}
                  className="img-fluid border-0"
                  alt="Agents"
                />
                <div className="offer-area">
                  <p className="fw-bold my-0">Avanish Kumar Srivastava</p>
                  <span className="para-text text-muted">Legal Advisor</span>
                  <p
                    className="offer-area-icon my-0"
                    onClick={() => navigate("/members/avinash-kumar")}
                  >
                    <i className="fa-solid fa-link"></i>
                  </p>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="my-2 offer-area-outer px-3">
                <img
                  src={RajKumar}
                  className="img-fluid border-0"
                  alt="Agents"
                />
                <div className="offer-area">
                  <p className="fw-bold my-0">Raj Kumar Misra</p>
                  <span className="para-text text-muted">Operational Head</span>
                  <p
                    className="offer-area-icon my-0"
                    onClick={() => navigate("/members/raj-kumar")}
                  >
                    <i className="fa-solid fa-link"></i>
                  </p>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="my-2 offer-area-outer px-3">
                <img
                  src={NirajPandey}
                  className="img-fluid border-0"
                  alt="Agents"
                />
                <div className="offer-area">
                  <p className="fw-bold my-0">Niraj Pandey</p>
                  <span className="para-text text-muted">Project Manager</span>
                  <p
                    className="offer-area-icon my-0"
                    onClick={() => navigate("/members/niraj-pandey")}
                  >
                    <i className="fa-solid fa-link"></i>
                  </p>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="my-2 offer-area-outer px-3">
                <img
                  src={KrishnaPandey}
                  className="img-fluid border-0"
                  alt="Agents"
                />
                <div className="offer-area">
                  <p className="fw-bold my-0">Krishna Kumar Pandey</p>
                  <span className="para-text text-muted">Project Manager</span>
                  <p
                    className="offer-area-icon my-0"
                    onClick={() => navigate("/members/krishna-kumar")}
                  >
                    <i className="fa-solid fa-link"></i>
                  </p>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="my-2 offer-area-outer px-3">
                <img
                  src={AbhishekRai}
                  className="img-fluid border-0"
                  alt="Agents"
                />
                <div className="offer-area">
                  <p className="fw-bold my-0">Abhishek Rai</p>
                  <span className="para-text text-muted">
                    Transportation Head
                  </span>
                  <p
                    className="offer-area-icon my-0"
                    onClick={() => navigate("/members/abhishek-rai")}
                  >
                    <i className="fa-solid fa-link"></i>
                  </p>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="my-2 offer-area-outer px-3">
                <img
                  src={SagarKataria}
                  className="img-fluid border-0"
                  alt="Agents"
                />
                <div className="offer-area">
                  <p className="fw-bold my-0">Sagar Kataria</p>
                  <span className="para-text text-muted">
                    Event & Activities Manager
                  </span>
                  <p
                    className="offer-area-icon my-0"
                    onClick={() => navigate("/members/sagar-kataria")}
                  >
                    <i className="fa-solid fa-link"></i>
                  </p>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </section> */}
      {/* Agents section ends */}
    </>
  );
};

export default Home;
